/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBDEPLOYLIST, GETDEPLOYINFO } from './constants'

export const getClubDeployList = (payload) => {
  return {
    type: GETCLUBDEPLOYLIST,
    payload,
  }
}

export const getDeployInfo = (payload) => {
  return {
    type: GETDEPLOYINFO,
    payload,
  }
}

//人员调配列表
export function fetchClubDeployList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/BossRoleList`
    return fetchData(endpoint).then((res) => {
      dispatch(getClubDeployList(res.data))
      return res
    })
  }
}

//获取用户信息
export function fetchGetAccount(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/GetAccount`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res.status === false) {
        dispatch(getDeployInfo({}))
        message.error('该手机号码还未绑定,请重新输入已绑定的手机号码')
      } else {
        dispatch(getDeployInfo(res.info))
      }
    })
  }
}
//添加,删除人员调配
export function fetchSettingDeploy(a, body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BossApi/${a}`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res.status == 1) {
        dispatch(fetchClubDeployList())
        message.success(res.detail)
      } else {
        message.error(res.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/action.js